import { useDeleteEntityApi } from "@/common/api/deleteEntityApi";
import { useDashboardStore } from "../stores/dashboardStore";

export function useDeleteDashboardApi() {

  const store = useDashboardStore();

  return useDeleteEntityApi({
    url: 'dashboard',
    translate: (t) => t.dashboard.actions.delete,
    async processOk(request) {
      store.remove(request.id);
      return Promise.resolve({
        ok: true
      });
    },
  })
}
